export default "__VITE_ASSET__zI1O5QfH__"